export enum ModifierType {
  settings = 1 << 0,
  clippy = 1 << 1,
  experimentalFeature = 1 << 3,
  lucasStatusMode = 1 << 4,
  idHighlightWaves = 1 << 5,
  enableSFX = 1 << 8,
  enableUserThemes = 1 << 9,
  sunAndMoon = 1 << 11,
  lisaControl = 1 << 12,
  bastiPriorityOrderDashboard = 1 << 13,
  eventComments = 1 << 14,
  coffeeStain = 1 << 15,
  ignoreSpecialAdmin = 1 << 16,
  LISA3 = 1 << 17,
  halloweenSpider = 1 << 18,
}
